module.exports = __webpack_public_path__ + "static/media/purple4.ed3b3acb.png";